// extracted by mini-css-extract-plugin
export default {"container":"styles_container__MW1uP","header":"styles_header__yN3oE","headerHovered":"styles_headerHovered__fhqRz","content":"styles_content__nenXF"};